import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4">
            内容分类
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            五大内容板块
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            无论你是果农、美食爱好者还是果园文化探索者，都能在这里找到感兴趣的内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group block bg-background-50 rounded-xl overflow-hidden hover:scale-[1.02] transition-transform duration-300"
            >
              <div className="h-36 md:h-40 overflow-hidden">
                <img
                  src={cat.coverUrl}
                  alt={cat.name}
                  title={`${cat.name} - 水蜜桃视频`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center">
                    <i className={`${cat.icon} text-primary-600 text-base`}></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 whitespace-nowrap">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-foreground-600 text-xs leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}